import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PressComponent } from './press.component';
import { PressRoutingModule } from './press-routing.module';
import { FooterModule } from 'app/partials/footer/footer.module';
import { MainNavbarModule } from 'app/partials/main-navbar/main-navbar.module';
import { NewsComponent } from './news/news.component';
import { NewsItemComponent } from './news/news-item/news-item.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { AnnouncementItemComponent } from './announcements/announcement-item/announcement-item.component';
import { StartModule } from 'app/wipperoz-core/start/start.module';
import { PressInquiriesComponent } from './press-inquiries/press-inquiries.component';
import { VisitBlogComponent } from './visit-blog/visit-blog.component';
import { MediaKitComponent } from './media-kit/media-kit.component';
import { IconsModule } from 'app/wipperoz-core/icons/icons.module';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [
    PressComponent,
    NewsComponent,
    NewsItemComponent,
    AnnouncementsComponent,
    AnnouncementItemComponent,
    PressInquiriesComponent,
    VisitBlogComponent,
    MediaKitComponent
  ],
  imports: [CommonModule, RouterModule, PressRoutingModule, FooterModule, StartModule, MainNavbarModule, IconsModule]
})
export class PressModule {}
